(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Greeting', Greeting);

    Greeting.$inject = ['$resource'];

    function Greeting ($resource) {
        var resourceUrl =  'api/greetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/greetings/filter', method: 'GET', isArray: true}
        });
    }
})();
